import { ColumnViewModel } from '../../shared/column-types';

export const VDA_ALL_EVIDENCE: ColumnViewModel = {
  columns: [
    'variantStrID',
    'diseaseName',
    'geneSymbol',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'gof_lof',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'chemical_effect',
    'pmYear',
    'journal_abbrv',
    'source',
    'variantDSI',
    'variantDPI',
    'pValue',
    'chromosome',
    'coord',
    'alleleFreqExome',
    'alleleFreqGenome',
    'riskAllele',
    'DBSNPclass',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'reference',
    'reference_type',
    'beta',
    'odds_ratio',
    'clinical_significance',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'variantStrID',
    'diseaseName',
    'geneSymbol',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'chemsInSentence',
    'pmYear',
    'journal_abbrv',
    'reference',
    'reference_type',
    'riskAllele',
    'beta',
    'odds_ratio',
  ],
};